import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useRef } from "react";

export default function PlatformMobileCarousel({ platforms, onSelect }) {
  const carouselRef = useRef(null); // reference for programmatic control

  return (
    <div className="block md:hidden w-screen relative py-8 overflow-hidden">
      {/* LEFT ARROW */}
      <button
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white p-2 rounded-full shadow"
        onClick={() => carouselRef.current?.prev()}
      >
        <LeftOutlined />
      </button>

      {/* RIGHT ARROW */}
      <button
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white p-2 rounded-full shadow"
        onClick={() => carouselRef.current?.next()}
      >
        <RightOutlined />
      </button>

      <Carousel
        ref={carouselRef}
        dots={true}          // pagination dots
        arrows={true}       // we use custom arrows
        // autoplay={true}      // auto-scroll
        // infinite={true}      // loop
        // autoplaySpeed={3500}
        swipeToSlide={true}  // swipe support
        slidesToShow={1}     // one slide at a time
      >
        {platforms.map((item, idx) => (
          <div key={idx} className="my-3 flex justify-center w-screen px-8 h-[200px] w-full">
            <div
              className="bg-white p-5 rounded-xl shadow cursor-pointer w-full h-[200px]"
              onClick={() => onSelect(idx)}
            >
              <div className="font-semibold text-lg">{item.title}</div>
              <div className="mt-3 text-sm text-slate-600">{item.desc}</div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
